module.exports = __webpack_public_path__ + "static/media/Group9302.56b62342.png";